"use strict";

import { FormCode, kttHistory } from '../config/index.json';
import moment from 'moment-timezone';

function getWITADate(tgl) {
    if (!tgl) return '-';
    return moment.tz(tgl, 'Asia/Makassar').format('YYYY-MM-DD');
}

function formatDate(ipDate) {
    if (!ipDate) return '-';
    return moment.tz(ipDate, 'Asia/Makassar').format('YYYY-MM-DD HH:mm:ss');
}

function formatDateOnly(ipDate) {
    if (!ipDate) return '-';
    return moment.tz(ipDate, 'Asia/Makassar').format('YYYY-MM-DD');
}

function jabatanDetail(postAs, index, formCode = "") {
    //TODO: need to refactor for simplification of switch case
    switch (postAs) {
      case "deptHead":
        if (formCode == "BIB-HSE-PPO-IZIN-TAMU") return "DIC / PJO";
        else if (formCode == "BIB-HSE-PPO-FRM-018-03" || formCode == "BIB-HSE-PPO-F-071-01" || formCode == "BIB-HSE-PPO-F-071-02") return "DIC / Kustodian";
        return "Dept. Head / Cust Dept.head";
      case "divHead":
        return "Div.Head / Cust Div.head";
      case "custodianDeptHead":
        return formCode == "BIB-HSE-ES-F-2.07-01" ? "DIC/Custodian" : "Custodian Dept Head";
      case "custodianDivHead":
        return formCode == "BIB-HSE-ES-F-2.07-01" ? "Div.Head Cust/Div.head" : "Custodian Div Head";
      case "ohsDeptHead":
        if (formCode == "BIB-HSE-PPO-F-071-01" || formCode == "BIB-HSE-PPO-F-071-02") return "OHS Departemen";
        return "OHS Dept Head";
      case "hseDivHead":
        return "HSE Div Head";
      case "approver":
        return formCode == "BIB-HSE-PPO-IZIN-TAMU" ? "KTT / HSE Head" : "KTT";
      case "teamLeader":
        return "Team Leader / Custodian Dept Head / Sec Head";
      case "pjo":
      case "secHead":
        return "Atasan / PJO / Section Head";
      case "karyawan":
        return "Pekerja";
      case "waskat":
        return `Waskat ${index + 1}`;
      case "atasan":
        return `Atasan / PJO / Section Head`;
      case "requestor":
        return "PJO/Section Head";
      case "verificator1": 
        return "DIC/Custodian";
      case "verificator2": 
        return "OHS Departemen";
      case "safetyInternal": 
        return "Safety Internal";
      case "safetyMitra": 
        return "Safety Mitra";
      default:
        return "approverDefault";
    }
}

function isApprover(isAuthenticated, ip, approvalUser, actionFrom = null) {
  /**
  * GROUPING PENGECEKAN GROUP LEVEL (ROLE) IPERMIT V2 - 13-08-2024
  * - KTT (hanya perlu pengecekan group level)
  * - SAFETYMITRA & PJO (perlu pengecekan department && company && group level && ipLocation)
  * selain role diatas (perlu pengecekan department && group level)
  * example: SECHEAD, DIVHEAD, DLL
  */
  
  if (!isAuthenticated || !('ipStatus' in ip)) return false;
  
  let wf = null;
  let setWf = ip.ipWorkflow;
  let setStatus = Number(ip.ipStatus);
  if (actionFrom === 'extendWaskat') {
    setWf = ip.ipExtendWorkflow;
    setStatus = Number(ip.ipExtendStatus);
  }
  const isOnApproval = Number(setStatus) === 2;
  const isOnClosing = Number(setStatus) === 10 && 'ipPengesahan' in ip && ip.ipPengesahan;
  if (isOnClosing) {
    setWf = ip.ipPengesahan.ipWorkflow;
  }
  
  for(const i of setWf) {
    if (Number(i.status) === 9) { wf = i; break; }
  }
  if (!wf || wf === null) return false;
  const isNeedApproval = Number(wf.status) === 9;
  const isKTT = approvalUser?.group_level?.includes('KTT');
  
  const correctGroupLevel = wf.matrix.some(el => approvalUser?.group_level.includes(el));
  const correctDepartment = Array.isArray(approvalUser.department)
    ? approvalUser.department.includes(ip.ipDeptDivisi)
    : (approvalUser.department === ip.ipDeptDivisi);
  const correctLocation = approvalUser.location[0] === ip.ipLocation[0].code;
  const correctCompanies = approvalUser.companies.includes(ip.ipPerusahaan);

  // cek role apakah user perlu validasi semua rule
  const needFullValidation = ['SAFETYMITRA','PJO'];
  const filterRole = approvalUser?.group_level.filter( el => !needFullValidation.includes(el));
  const fullValidation = needFullValidation.some( el => approvalUser?.group_level.includes(el) ) && filterRole.length < 1; // cek apakah mempunyai role safetymitra dan pjo saja atau punya role yang lain
  
  // Logic button approval
  if (ip.ipForm === FormCode.izinJangkaPendek && actionFrom === 'extendWaskat') {
    if (isOnApproval && isNeedApproval && correctGroupLevel) {
      if (isKTT) return true;
      if (fullValidation) return correctGroupLevel && correctDepartment && correctLocation && correctCompanies;
      return correctDepartment;
    }
    
  } else if (ip.ipForm === FormCode.izinJangkaPendek) {
    // logic for permit jangka pendek / waskat
    if (isOnApproval && isNeedApproval) {
      const isValidApprover = (wf.email == approvalUser.email) && (wf.postAs == 'waskat' || wf.postAs == 'atasan')
      const isFreeApprover = wf.postAs == 'karyawan' || wf.postAs == 'atasan' || wf.postAs == 'waskat';
      if (isFreeApprover && isValidApprover) {
        return true;
      } else if (!isFreeApprover) {
        if (isKTT) return true;
        if (fullValidation) return correctGroupLevel && correctDepartment && correctLocation && correctCompanies;
        return correctGroupLevel && correctDepartment;
      }
    }
    
  } else if ([FormCode.izinKerjaRemoteArea, FormCode.izinTamu].includes(ip.ipForm)) {
    if (isOnApproval && isNeedApproval && correctGroupLevel) {
      if (isKTT) return true;
      if (fullValidation) return correctGroupLevel && correctDepartment && correctLocation && correctCompanies;

      if(wf.postAs == "verificator2" || wf.postAs == "approver") {
        return true;
      } else if(correctDepartment) {
        return true;
      }
    }
    
  } else if (FormCode.izinKegiatanProyek === ip.ipForm && ['izinProyekEmail','izinUsahaJasa'].includes(actionFrom)) {
    if (isOnApproval && isNeedApproval && correctGroupLevel) {
      if (isKTT) return true;
      if (fullValidation) return correctGroupLevel && correctDepartment && correctLocation && correctCompanies;

      if(wf.postAs == "verificator2" || wf.postAs == "approver") {
        return true;
      } else if(correctDepartment) {
        return true;
      }
    } else if (isOnClosing) {
      const isValidApprover = (wf.email === approvalUser.email) && (wf.postAs === approvalUser.postAs)
      const isFreeApprover = wf.postAs === 'pemegangIzin';
      if (isFreeApprover && isValidApprover) {
        return true;
      } else if (!isFreeApprover) {
        if (approvalUser.postAs == 'pemegangIzin') return false;
        if (isKTT) return true;
        if (fullValidation) return correctGroupLevel && correctDepartment && correctLocation && correctCompanies;
        return correctGroupLevel && correctDepartment;
      }
    }
  } else {
    if ((isOnApproval || isOnClosing) && isNeedApproval && correctGroupLevel) {
      if (isKTT) return true;
      if (fullValidation) return correctGroupLevel && correctDepartment && correctLocation && correctCompanies;

      if(wf.postAs == "verificator2" || wf.postAs == "approver") {
        return true;
      } else if(correctDepartment) {
        return true;
      }
    }
  }
  
  return false;
}

function getActiveKTTName() {
    const active = (kttHistory || []).find(e => e.endDate === null);
    return active ? active.name : '-';
}

function isKTTMatrix(matrix) {
    if (typeof matrix === 'string' || Array.isArray(matrix)) {
        return matrix.includes('KTT');
    }
    return false;
}

function getKTTApproverName(item) {
    if (!item || !isKTTMatrix(item.matrix)) {
        return item ? item.name : '-';
    }
    const activeName = getActiveKTTName();
    if (!item.date) return activeName;
    const approvalDate = moment.tz(item.date, 'Asia/Makassar').format('YYYY-MM-DD');
    const entry = (kttHistory || []).find(e => {
        const afterStart = !e.startDate || approvalDate >= e.startDate;
        const beforeEnd = !e.endDate || approvalDate <= e.endDate;
        return afterStart && beforeEnd;
    });
    return entry ? entry.name : activeName;
}

function isKTTSubstitute(item) {
    if (!item || !isKTTMatrix(item.matrix)) return false;
    if (Number(item.status) !== 7 && Number(item.status) !== 8) return false;
    return getKTTApproverName(item) !== item.name;
}

function getKTTApproverTitle(item) {
    if (!item || !isKTTMatrix(item.matrix)) {
        return item ? (item.title ?? item.position ?? '-') : '-';
    }
    return 'Kepala Teknik Tambang';
}

export default {
    getWITADate,
    formatDate,
    formatDateOnly,
    jabatanDetail,
    isApprover,
    getKTTApproverName,
    isKTTSubstitute,
    getKTTApproverTitle,
}
